module.exports = __webpack_public_path__ + "static/media/safari.d00b5017.svg";